export const clamp=(value,lowerBound,upperBound)=>Math.min(Math.max(lowerBound,value),upperBound);